import hotToast from 'react-hot-toast';

export const useToast = () => {
  return {
    toast: ({ title, description, variant = 'default', ...props }) => {
      const message = description ? `${title}\n${description}` : title;
      
      switch (variant) {
        case 'destructive':
          return hotToast.error(message, props);
        case 'success':
          return hotToast.success(message, props);
        case 'warning':
          return hotToast(message, { 
            icon: '⚠️',
            ...props 
          });
        default:
          return hotToast(message, props);
      }
    }
  };
};

export const toast = useToast().toast; 